class navSubmenu {
  constructor(settings) {
    this.container = settings.container;
    this.expandedDesktop = settings.expandedDesktop;
    this.expandedMobile = settings.expandedMobile;
    this.expanded = false;
    this.mediaQuery = settings.mediaQuery;
    this.toggleEvent = null;
    this.trigger = settings.trigger;
  }
  bindEvents() {
    this.trigger.addEventListener('click', this.toggleVisibility.bind(this));
    this.mediaQuery.addEventListener('change', this.resetState.bind(this, true));
  }
  resetState(dispatch) {
    this.setExpandedDefault();
    this.setState(dispatch);
  }
  setExpandedDefault() {
    this.expanded = this.mediaQuery.matches ? this.expandedDesktop : this.expandedMobile;
  }
  setState(dispatch = true) {
    this.trigger.setAttribute('aria-expanded', this.expanded);
    this.container.hidden = !this.expanded;
    if (dispatch === true) {
      this.trigger.dispatchEvent(this.toggleEvent);
    }
  }
  toggleVisibility() {
    this.expanded = !this.expanded;
    this.setState();
  }
  init() {
    this.toggleEvent = new CustomEvent('toggle', {
      detail: this,
    });
    this.setExpandedDefault();
    this.setState();
    this.bindEvents();
  }
}

export default navSubmenu;
